import { render, staticRenderFns } from "./SpecStockForm.vue?vue&type=template&id=51f16fbc&scoped=true"
import script from "./SpecStockForm.vue?vue&type=script&lang=js"
export * from "./SpecStockForm.vue?vue&type=script&lang=js"
import style0 from "./SpecStockForm.vue?vue&type=style&index=0&id=51f16fbc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f16fbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51f16fbc')) {
      api.createRecord('51f16fbc', component.options)
    } else {
      api.reload('51f16fbc', component.options)
    }
    module.hot.accept("./SpecStockForm.vue?vue&type=template&id=51f16fbc&scoped=true", function () {
      api.rerender('51f16fbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/goodsList/components/SpecStockForm.vue"
export default component.exports